import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';
import type { Option } from '../lib/enums.ts';

export function Field({
  id,
  label,
  required,
  hint,
  error,
  span2,
  children,
}: {
  id: string;
  label: ReactNode;
  required?: boolean;
  hint?: ReactNode;
  error?: string;
  span2?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={`field ${error ? 'has-error' : ''} ${span2 ? 'span-2' : ''}`}>
      <label htmlFor={id} className='field-label'>
        {label}
        {required ? <span className='req' aria-hidden='true'>*</span> : <span className='opt'>(पर्यायी)</span>}
      </label>
      {children}
      {error ? <p className='field-error' id={`${id}-err`}>{error}</p> : hint ? <p className='field-hint' id={`${id}-hint`}>{hint}</p> : null}
    </div>
  );
}

export function TextInput({ invalid, ...p }: InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }) {
  return (
    <input
      className='input'
      aria-invalid={invalid || undefined}
      aria-describedby={p.id ? (invalid ? `${p.id}-err` : `${p.id}-hint`) : undefined}
      {...p}
    />
  );
}

export function TextArea({ invalid, ...p }: TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }) {
  return <textarea className='input textarea' aria-invalid={invalid || undefined} {...p} />;
}

export function Select({
  options,
  placeholder = '-- निवडा --',
  invalid,
  ...p
}: SelectHTMLAttributes<HTMLSelectElement> & { options: Option[]; placeholder?: string; invalid?: boolean }) {
  return (
    <select className='input select' aria-invalid={invalid || undefined} {...p}>
      <option value=''>{placeholder}</option>
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
